import { render, staticRenderFns } from "./admin-loading.vue?vue&type=template&id=ac3ac70e&scoped=true&"
import script from "./admin-loading.vue?vue&type=script&lang=js&"
export * from "./admin-loading.vue?vue&type=script&lang=js&"
import style0 from "./admin-loading.vue?vue&type=style&index=0&id=ac3ac70e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac3ac70e",
  null
  
)

export default component.exports